package xim.poc.game.configuration.v0.tactics.behaviors

import xim.poc.game.*
import xim.poc.game.configuration.SkillApplierHelper
import xim.poc.game.configuration.constants.*
import xim.poc.game.configuration.v0.TacticsInstinct
import xim.poc.game.configuration.v0.tactics.*
import xim.poc.game.event.ActorGainStatusEvent
import xim.poc.game.event.Event

class TacticsColkhabBehavior(actorState: ActorState): TacticsBehaviorController(actorState) {

    private val children = ArrayList<ActorPromise>()

    override fun onBehaviorInitialized(): List<Event> {
        actorState.getUnit().instincts += TacticsInstinct(TacticsInstincts.pass.id, 0)
        return emptyList()
    }

    override fun tacticsUpdate(elapsedFrames: Float): List<Event> {
        children.removeAll { it.isObsolete() }
        actorState.appearanceState = if (children.isNotEmpty()) { 1 } else { 0 }
        return emptyList()
    }

    override fun applyTacticsBehaviorBonuses(aggregate: CombatBonusAggregate) {
        aggregate.knockBackResistance += 100

        if (children.isEmpty()) { return }
        aggregate.physicalDamageTaken -= 1000
        aggregate.magicalDamageTaken -= 1000
    }

    override fun onSkillExecutedScoped(primaryTargetContext: SkillApplierHelper.TargetEvaluatorContext): List<Event> {
        if (wantsToUseDroningWhirlwind()) {
            displayCharging(primaryTargetContext.context)
        }

        if (primaryTargetContext.skill == mskillDroningWhirlwind_2749) {
            endCharging()
            actorState.appearanceState = 1
            AttackContext.compose(primaryTargetContext.context) { createAdds() }
        }

        return listOf(ActorGainStatusEvent(
            sourceId = actorState.id,
            targetId = actorState.id,
            context = primaryTargetContext.context,
            statusState = StatusEffectState(StatusEffect.Blink).also {
                it.counter = 1
                it.displayCounter = true
            }
        ))
    }

    override fun getSelectableSkills(): List<SkillId> {
        return if (wantsToUseDroningWhirlwind() && isDisplayCharging()) {
            listOf(mskillDroningWhirlwind_2749)
        } else if (auraIsActive()) {
            if (canUseIncisiveApotheosis()) { listOf(mskillIncisiveApotheosis_2751) } else { listOf(mskillIncisiveDenouement_2750) }
        } else {
            super.getSkills() - setOf(mskillDroningWhirlwind_2749, mskillIncisiveDenouement_2750, mskillIncisiveApotheosis_2751)
        }
    }

    override fun estimateSkillValue(query: TacticsSkillQuery): Float {
        val baseScore = super.estimateSkillValue(query)
        if (!auraIsActive()) { return baseScore }

        // Prefer not to move during this phase
        val movement = 1 + query.destinationPosition.distance(query.originalPosition)
        return baseScore / movement
    }

    private fun wantsToUseDroningWhirlwind(): Boolean {
        return !hasUsedSkill(mskillDroningWhirlwind_2749) && actorState.getHpp() <= 0.556f
    }

    private fun canUseIncisiveApotheosis(): Boolean {
        return getSkillUsedCount(mskillIncisiveDenouement_2750) >= 3
    }

    private fun createAdds() {
        createAdd(PanelPosition(0, 2))
        createAdd(PanelPosition(4, 2))
    }

    private fun createAdd(basePosition: PanelPosition) {
        val match = getMatch()
        val position = match.nearestUnclaimedPosition(basePosition) ?: return

        val unit = TacticsState.makeUnit(tacticsJob_Bee, level = actorState.getUnitLevel().copy())
        val beeConfig = TacticsUnitConfig(bossUnit = false, xpMultiplier = 0f, skillOverride = listOf(mskillSharpSting_78))
        children += match.createUnit(position = position, type = ActorType.Enemy, unit = unit, startingTp = 700, unitConfig = beeConfig)
    }

    private fun auraIsActive(): Boolean {
        return actorState.appearanceState == 1
    }

}